import React from 'react'
import classNames from 'classnames'
import { FormattedMessage, useIntl } from 'react-intl'

import { ImgSanity } from '@slite/components'

import { Section } from '../../components/Section'
import { getAiSearchWhereYouWork } from './data'

export function SectionAiSearchWhereYouWork() {
  const intl = useIntl()
  const items = getAiSearchWhereYouWork(intl)

  return (
    <Section
      containerVerticalPadding={120}
      background="moon-dust-lighter"
      className="position-relative"
    >
      <div
        className={classNames(
          'flexbox flexbox-column flexbox-align-center text-align-center',
          'margin-left-auto margin-right-auto'
        )}
        style={{ maxWidth: 800 }}
      >
        <h2
          className="font-family-title font-size-2 line-height-normal font-weight-medium shade-05"
          style={{ letterSpacing: '-0.02em' }}
        >
          <FormattedMessage
            id="aiSearch.where.title"
            defaultMessage="Lives wherever you work"
          />
        </h2>
        <p
          className="font-size-4 line-height-large margin-top-16 shade-10"
          style={{ maxWidth: 600 }}
        >
          <FormattedMessage
            id="aiSearch.where.subtitle"
            defaultMessage="Bring your company search into the tools your team is already using."
          />
        </p>
      </div>

      <div
        className={classNames(
          'grid-12 grid-gap-24 margin-top-40',
          'margin-left-auto margin-right-auto'
        )}
        style={{ maxWidth: 1100 }}
      >
        {items.map((item, idx) => (
          <div
            key={idx}
            className={classNames(
              'grid-span-4-large grid-span-4-medium grid-span-12-small',
              'flexbox flexbox-column flexbox-gap-16 background-shade-100 radius-larger'
            )}
            style={{
              overflow: 'hidden',
              border: '1px solid var(--alpha-shade-40)',
            }}
          >
            <ImgSanity
              src={item.image}
              alt={item.title}
              className="radius-semilarger"
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
              }}
            />
            <div className="padding-horizontal-24 padding-bottom-24 padding-top-8">
              <div className="font-size-3 font-family-title font-weight-medium line-height-title shade-05">
                {item.title}
              </div>
              <div className="font-size-5 shade-20 margin-top-8">
                {item.desc}
              </div>
            </div>
          </div>
        ))}
      </div>
    </Section>
  )
}
